import { fetchLang } from "@util/http";

const headers = {
  "content-type": "application/json",
};
//查询所有团队绑定关系
export function queryAllBindings(params) {
  return fetchLang("/api/admin/ml/queryAllBindings", {
    method: "POST",
    headers,
    body: JSON.stringify(params),
  }).then((res) => res.json());
}

//根据状态查询语言包数据 status 0-未生效 1-生效 null-全部
export function queryByStatus(params) {
  return fetchLang("/api/admin/ml/queryByStatus", {
    method: "POST",
    headers,
    body: JSON.stringify(params),
  }).then((res) => res.json());
}

//生效语言包
export function effectLanguagePack(params) {
  return fetchLang(`/api/admin/ml/effectLanguagePack`, {
    method: "POST",
    headers,
    body: JSON.stringify(params),
  }).then((res) => res.json());
}

//查询团队所有语言包信息
export function getTeamLanguagePacks(params) {
  return fetchLang("/api/admin/ml/getTeamLanguagePacks", {
    method: "POST",
    headers,
    body: JSON.stringify(params),
  }).then((res) => res.json());
}

// 绑定团队指定语言包
export function bindLangPack(params) {
  return fetchLang("/api/admin/ml/bind", {
    method: "POST",
    headers,
    body: JSON.stringify(params),
  }).then((res) => res.json());
}

// 查询团队指定语言的语言包
export function getByTeamAndCode(params) {
  return fetchLang("/pi/admin/ml/getByTeamAndCode", {
    method: "POST",
    headers,
    body: JSON.stringify(params),
  }).then((res) => res.json());
}

// 新建官方语言包
export function createLang(params) {
  return fetchLang(`/api/admin/ml/create`, {
    method: "POST",
    headers,
    body: JSON.stringify(params),
  }).then((res) => res.json());
}

// 新建官方语言包
export function delLang(params) {
  return fetchLang(`/api/admin/ml/delete`, {
    method: "POST",
    headers,
    body: JSON.stringify(params),
  }).then((res) => res.json());
}
// 新增版本
export function addVersion(params) {
  return fetchLang("/api/admin/ml/addVersion", {
    method: "POST",
    headers,
    body: JSON.stringify(params),
  }).then((res) => res.json());
}

// 获取其他端口的语言包数据
export function getDataByPort(params) {
  return fetchLang(`/api/admin/ml/getDataByPort`, {
    method: "POST",
    headers,
    body: JSON.stringify(params),
  }).then((res) => res.json());
}

// 修改版本数据
export function updateVersion(params) {
  return fetchLang(`/api/admin/ml/updateVersion`, {
    method: "POST",
    headers,
    body: JSON.stringify(params),
  }).then((res) => res.json());
}

//根据id查询语言包
export function queryById(params) {
  return fetchLang("/api/admin/ml/queryById", {
    method: "POST",
    headers,
    body: JSON.stringify(params),
  }).then((res) => res.json());
}
//查询语言列表
export function getLanguageAll() {
  return fetchLang("/api/multiLanguage/getLanguageAll", {
    method: "GET",
    headers,
  }).then((res) => res.json());
}

//管理员管理语言包商品
export function adminQueryLanguageList(params) {
  return fetchLang("/api/admin/product/adminQueryLanguageList", {
    method: "POST",
    headers,
    body: JSON.stringify(params),
  }).then((res) => res.json());
}

//管理员管理语言包商品
export function addLanguageProduct(params) {
  return fetchLang("/api/admin/product/addLanguageProduct", {
    method: "POST",
    headers,
    body: JSON.stringify(params),
  }).then((res) => res.json());
}

//管理员管理语言包商品
export function updateLanguageProduct(params) {
  return fetchLang("/api/admin/product/updateLanguageProduct", {
    method: "POST",
    headers,
    body: JSON.stringify(params),
  }).then((res) => res.json());
}

//管理员管理语言包商品
export function deleteLanguageProduct(params) {
  return fetchLang("/api/admin/product/deleteLanguageProduct", {
    method: "POST",
    headers,
    body: JSON.stringify(params),
  }).then((res) => res.json());
}
//根据团队id和目标语言查询翻译进度
export function queryAutoMtFlow(params) {
  return fetchLang("/api/autoMt/queryAutoMtFlow", {
    method: "POST",
    headers,
    body: JSON.stringify(params),
  }).then((res) => res.json());
}
//批量查询自动翻译流程状态
export function queryAutoMtFlowBatch(params) {
  return fetchLang("/api/autoMt/queryAutoMtFlowBatch", {
    method: "POST",
    headers,
    body: JSON.stringify(params),
  }).then((res) => res.json());
}
//自动翻译进度汇总查询
export function queryAutoMtAggregate(params) {
  return fetchLang("/api/autoMt/queryAutoMtAggregate", {
    method: "POST",
    headers,
    body: JSON.stringify(params),
  }).then((res) => res.json());
}

//团队查询语言包列表
export function queryLanguageList(params) {
  return fetchLang("/api/product/queryLanguageList", {
    method: "POST",
    headers,
    body: JSON.stringify(params),
  }).then((res) => res.json());
}

//团队查询语言包列表
export function payOrder(params) {
  return fetchLang("/api/payOrder/add", {
    method: "POST",
    headers,
    body: JSON.stringify(params),
  }).then((res) => res.json());
}

//团队查询批量翻译状态
export function queryLanguagePackTranslateStatusByTeam(params) {
  return fetchLang("/api/product/queryLanguagePackTranslateStatusByTeam", {
    method: "POST",
    headers,
    body: JSON.stringify(params),
  }).then((res) => res.json());
}

// 查询团队默认语言选项（中文+已开通语言，标识当前默认语言）
export function findTeamLanguageOptions(params) {
  return fetchLang("/api/team/findTeamLanguageOptions?" + new URLSearchParams(params).toString(), {
    method: "GET",
    headers,
  }).then((res) => res.json());
}

// 保存团队默认语言
export function saveTeamDefaultLanguage(params) {
  return fetchLang("/api/team/saveTeamDefaultLanguage", {
    method: "POST",
    headers,
    body: JSON.stringify(params),
  }).then((res) => res.json());
}

// 查询团队语言绑定，后端按 sort 升序返回
export function findTeamLanguageBindings(params) {
  return fetchLang(
    "/api/team/findTeamLanguageBindings?" + new URLSearchParams(params).toString(),
    {
      method: "GET",
      headers,
    }
  ).then((res) => res.json());
}

// 保存团队语言完整排序
export function sortTeamLanguages(params) {
  return fetchLang("/api/team/sortTeamLanguages", {
    method: "POST",
    headers,
    body: JSON.stringify(params),
  }).then((res) => res.json());
}

// 保存团队语言开关 true-开启 false-关闭
export function saveTeamLanguageSwitch(params) {
  return fetchLang("/api/team/saveTeamLanguageSwitch", {
    method: "POST",
    headers,
    body: JSON.stringify(params),
  }).then((res) => res.json());
}
